import { promiseObject } from '../system/promise-proxies';
/**
  @module @ember-data/store
*/

/**
 * Get the materialized model from the internalModel/promise
 * that returns an internal model and return it in a promiseObject.
 *
 * Useful for returning from find methods
 *
 * @internal
 */
export default function promiseRecord(internalModelPromise, label) {
  let toReturn = internalModelPromise.then(internalModel => internalModel.getRecord());
  return promiseObject(toReturn, label);
}